import { Component } from "@angular/core";

@Component({
	templateUrl: "./main.component.html",
})
export class MainComponent {}
